import {
  ref, toRefs, watchEffect, watch,
} from '@nuxtjs/composition-api';

import { UseRainbowContext } from '~/context/RainbowContext';

import loadStylesheet from '../functions/shared/loadStylesheet';
import fetchActiveMarkerBloczekFromStore from '../functions/szukaj/data/fetchActiveMarkerBloczekFromStore';
import fetchMarkersFromStore from '../functions/szukaj/data/fetchMarkersFromStore';
import getMapFunctions from '../functions/szukaj/getMapFunctions';
import buildServiceConfig from '../functions/szukaj/serviceConfig/buildServiceConfig';
import TClusterRef from '../types/clusterRef';
import IMapService from '../types/IMapService';
import IMapSzukajServiceConfig from '../types/IMapSzukajServiceConfig';
import TMapRef from '../types/mapRef';

export const useMapServiceSzukaj = (service: IMapService) => {
  const { emit } = service;
  const mapRef = ref() as TMapRef;
  const cluster = ref() as unknown as TClusterRef;
  const rainbowContext = UseRainbowContext();
  const serviceConfig: IMapSzukajServiceConfig = buildServiceConfig({
    mapRef,
    $ua: rainbowContext.$ua,
    cluster,
  });

  fetchMarkersFromStore(serviceConfig.markersInnerState);
  fetchActiveMarkerBloczekFromStore(serviceConfig.mapState);
  const mapFunctions = getMapFunctions(serviceConfig);

  watchEffect(() => {
    loadStylesheet(service);
  });
  watch(mapRef, async () => {
    if (!mapRef || !mapRef.value) return;

    if (!mapFunctions.hasAtOneLeastWithCoords()) {
      emit('noMarkers');
      return;
    }

    await mapFunctions.init(serviceConfig);
  });
  return {
    ...toRefs(serviceConfig.mapState),
    ...mapFunctions,
    config: ref(serviceConfig.config),
    clusterDom: ref(mapFunctions.buildCluster()),
    markersInnerState: toRefs(serviceConfig.markersInnerState),
    mapRef,
    cluster,
  };
};
export default useMapServiceSzukaj;
